import { I18nextProvider } from "react-i18next";
import { App } from "./App";
import { muiTheme } from "src/theme/themeConfiguration";
import { i18n } from "@translations/i18n";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import createCache from "@emotion/cache";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import { CacheProvider } from "@emotion/react";
import { TssCacheProvider } from "tss-react";

const muiCache = createCache({
    key: "mui",
    prepend: true,
});

const tssCache = createCache({
    key: "tss",
});

const container = document.getElementById("root");
// Mandatory, refer to the documentation
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
    <BrowserRouter>
        <CacheProvider value={muiCache}>
            <TssCacheProvider value={tssCache}>
                <ThemeProvider theme={muiTheme}>
                    {/* Waiting for update */}
                    {/* @ts-ignore */}
                    <I18nextProvider i18n={i18n}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <div style={{ display: "flex" }}>
                                <App />
                            </div>
                        </LocalizationProvider>
                    </I18nextProvider>
                </ThemeProvider>
            </TssCacheProvider>
        </CacheProvider>
    </BrowserRouter>
);
